(function (angular) {
	'use strict';

	angular.module('PinMeTo.elm', ['jm.i18next']).component('pmtElm', {
		template: '<div><div></div></div>',
		controller: RunElm,
		bindings: {
			module: '@',
			args: '<',
			subscriptions: '<',
			version: '@',
			user: '<',
			featureFlags: '<',
			pmtEnv: '<',
			pageTitle: '@',
			filter: '<'
		}
	});

	RunElm.$inject = ['$element', 'pmtElmService', '$i18next', '$window', '$scope', '$location'];
	//jshint maxparams: 6
	function RunElm($element, pmtElmService, $i18next, $window, $scope, $location) {
		var $ctrl = this;
		$ctrl.$onInit = function () {
			const args = { ...$ctrl.args };
			['user', 'featureFlags', 'pmtEnv', 'filter'].forEach(p => {
				if ($ctrl[p]) {
					args[p] = $ctrl[p];
				}
			});

			const argsWithExtras = {
				pmtEnv: window.pmtEnv,
				...args,
				translations: pmtElmService.getTranslation(),
				language: $i18next.i18n.language || 'en',
				url: $location.absUrl()
			};

			pmtElmService.initialize(
				$element,
				$ctrl.module,
				argsWithExtras,
				$ctrl.subscriptions,
				$ctrl.version
			);
			if ($ctrl.user && $ctrl.pageTitle) {
				$window.document.title =
					$ctrl.user.selectedSite.displayName + ': ' + ($i18next.t($ctrl.pageTitle) || '');
			}

			const sendData = (portName, data) => {
				if (pmtElmService.verifyPortExist($ctrl.module, portName)) {
					pmtElmService.sendData($ctrl.module, portName, data);
				}
			};
			$ctrl.deregisterUrlListener = $scope.$on('$locationChangeSuccess', function (_event, newUrl) {
				sendData('urlChange', decodeURI(newUrl));
			});
			$ctrl.langChangeListener = lng => {
				const portName = `in_${$ctrl.module.replace(/\./g, '_')}_languageChanged`;
				sendData(portName, pmtElmService.getTranslation(lng));
			};
			// might not be needed, we refresh the page on language change
			$i18next.i18n.on('languageChanged', $ctrl.langChangeListener);
		};

		$ctrl.$onDestroy = function () {
			$i18next.i18n.off('languageChanged', $ctrl.langChangeListener);
			$ctrl.deregisterUrlListener?.();
			pmtElmService.deactivate($ctrl.module, $ctrl.subscriptions);
		};
	}
})(window.angular);
